define.alias("shared/components/shared/color-picker/selector", "media/components/shared/color-picker/selector");